<app-apps-banner></app-apps-banner>

<section class="mt-5 emission-calculator">
  <div class="container">
    <div class="row pb-80">
      <div class="col-lg-8 pe-md-4 pe-xl-5 border-right sm-border-none">

        <div class="border-bottom pb-3 d-md-none d-block">
          <!-- <p class="back-link">
          <i class="fa fa-angle-left pe-1" aria-hidden="true"></i> Back to all apps
        </p> -->
        <a class="back-link linked" routerLink="/apps">
          <i class="fa fa-angle-left pe-1" aria-hidden="true"></i> Back to all apps
        </a>

        <div class="d-flex">
          <img src="../assets/images/icons/emission-calculator.png" class="card-img-top img-fluid app-img me-4" alt="Container Specification">
          <h2>Emission Calculator</h2>
        </div>
      </div>

      <div class="d-md-flex align-items-md-center border-bottom pb-3 d-none d-md-flex">
        <img src="../assets/images/icons/emission-calculator.png" class="card-img-top img-fluid app-img me-4" alt="Container Specification">
        <div>
          <!-- <p class="back-link mb-0">
          <i class="fa fa-angle-left pe-1" aria-hidden="true"></i> Back to all apps
        </p> -->
        <a class="back-link linked" routerLink="/apps">
          <i class="fa fa-angle-left pe-1" aria-hidden="true"></i> Back to all apps
        </a>
        <h2>Emission Calculator</h2>
      </div>
    </div>

    <div class="row border-bottom mb-3">
      <div class="col-lg-8">
        <form class="apps-form-input d-lg-flex align-items-lg-center">
          <div class="form-group d-md-flex align-items-md-center mb-0 w-100">
            <label for="exampleFormControlSelect1" class="text-white w-100">Select Mode of Transportation</label>
            <select class="form-select" id="exampleFormControlSelect1" [ngModelOptions]="{standalone: true}" [(ngModel)]="cTransportationMode" (ngModelChange)="onChangeTransport()">
              @for (item of modeOfTransportationList; track item) {
                <option [value]="item.value">
                  {{item.name}}
                </option>
              }
            </select>
          </div>
        </form>
      </div>

    </div>

    <div class="bg-gray p-3">
      <p class="pb-2"><strong>Enter details of your cargo</strong></p>
      <form [formGroup]="emissionCalForm" (ngSubmit)="onSubmit(emissionCalForm)" class="emission-calculator-cargo">
        <div class="row">
          <div class="form-group pe-md-0" [ngClass]="cTransportationMode == 'TRUCK' ? 'col-md-3' : 'col-md-4' ">
            <input id="origin-address" placeholder="Origin Address" formControlName="cOriginAddress" type="text" class="form-control" [ngbTypeahead]="searchOriginAddress" [inputFormatter]="formatterOriginAddress" [resultFormatter]="formatterOriginAddress" [editable]='false'
              />
              <!-- <input type="text" class="form-control" formControlName="originAddress" id="origin-address" placeholder="Origin Address"> -->
              @if (submitted && f.cOriginAddress.errors) {
                <div class="invalid-feedback">
                  @if (f.cOriginAddress.errors.required) {
                    <div>Origin Address is required</div>
                  }
                </div>
              }
              @if (searching_1) {
                <small class="form-text text-muted searching">searching...</small>
              }
            </div>
            <div class="form-group col-md-4 pe-md-0" [ngClass]="cTransportationMode == 'TRUCK' ? 'd-none' : '' ">
              <input id="origin-airport" [placeholder]="cTransportationMode==='TST' || cTransportationMode==='SEA' ?'Origin Port':'Origin Airport'" formControlName="cOriginPort" type="text" class="form-control" [ngbTypeahead]="searchOriginPort" [inputFormatter]="formatterOriginPort"
                [resultFormatter]="formatterOriginPort" [editable]='false' />
                <!-- <input type="text" class="form-control" formControlName="originPort" id="origin-airport" placeholder="Origin Airport"> -->
                @if (submitted && f.cOriginPort.errors) {
                  <div class="invalid-feedback">
                    @if (f.cOriginPort.errors.required) {
                      <div>Origin Port is required</div>
                    }
                  </div>
                }
                @if (searching_4) {
                  <small class="form-text text-muted searching">searching...</small>
                }
              </div>
              <div class="form-group col-md-4" [ngClass]="cTransportationMode == 'TRUCK' ? 'd-none' : '' ">
                <input id="destination-airport" [placeholder]="cTransportationMode==='TST' || cTransportationMode==='SEA' ?'Destination Port':'Destination Airport'" formControlName="cDestinationPort" type="text" class="form-control" [ngbTypeahead]="searchDestinationPort"
                  [inputFormatter]="formatterDestinationPort" [resultFormatter]="formatterDestinationPort" [editable]='false' />
                  <!-- <input type="text" class="form-control" formControlName="destinationPort" id="destination-airport" placeholder="Destination Airport"> -->
                  @if (submitted && f.cDestinationPort.errors) {
                    <div class="invalid-feedback">
                      @if (f.cDestinationPort.errors.required) {
                        <div>Destination Port is required</div>
                      }
                    </div>
                  }
                  @if (searching_3) {
                    <small class="form-text text-muted searching">searching...</small>
                  }
                </div>
                <div class="form-group  pe-md-0" [ngClass]="cTransportationMode == 'TRUCK' ? 'col-md-3' : 'col-md-4' ">
                  <input id="destination-address" placeholder="Destination Address" formControlName="cDestinationAddress" type="text" class="form-control" [ngbTypeahead]="searchDestinationAddress" [inputFormatter]="formatterDestinationAddress" [resultFormatter]="formatterDestinationAddress"
                    [editable]='false' />
                    <!-- <input type="text" class="form-control" formControlName="destinationAddress" id="destination-address" placeholder="Destination Address"> -->
                    @if (submitted && f.cDestinationAddress.errors) {
                      <div class="invalid-feedback">
                        @if (f.cDestinationAddress.errors.required) {
                          <div>Destination Address is required</div>
                        }
                      </div>
                    }
                    @if (searching_2) {
                      <small class="form-text text-muted searching">searching...</small>
                    }
                  </div>
                  <div class="form-group pe-md-0" [ngClass]="cTransportationMode == 'TRUCK' ? 'col-md-3' : 'col-md-4' ">
                    <input type="text" class="form-control" (paste)="onValuePaste($event)" (keypress)="numberOnly($event)" formControlName="iCargoWeight" id="copy-weight" placeholder="Cargo Weight in kgs">
                    @if (submitted && f.iCargoWeight.errors) {
                      <div class="invalid-feedback">
                        @if (f.iCargoWeight.errors.required) {
                          <div>Cargo Weight is required</div>
                        }
                      </div>
                    }
                  </div>
                  <div class="form-group " [ngClass]="cTransportationMode == 'TRUCK' ? 'col-md-3' : 'col-md-4' ">
                    <button type="submit" class="btn btn-search">SEARCH</button>
                  </div>
                </div>
              </form>

              <div style="position: relative;">
                @if (isRuslatTableLoader) {
                  <div class="loader">
                    <div class="loader-icon">
                      <i class="fa fa-circle-o-notch fa-spin fa-3x fa-fw"></i>
                      <span class="sr-only">Loading...</span>
                    </div>
                  </div>
                }
                @if (arr.length > 0) {
                  <table class="table table-bordered">
                    <thead>
                      <th>From</th>
                      <th>To</th>
                      <th>Transport</th>
                      <th>Distance</th>
                      <th>CO2</th>
                    </thead>
                    <tbody>
                      @for (ele of arr; track ele) {
                        <tr>
                          <td>{{ele.From}}</td>
                          <td>{{ele.To}}</td>
                          <td>{{ele.Transport}}</td>
                          <td>{{ele.Distance}}</td>
                          <td>{{ele.CO2}}</td>
                        </tr>
                      }
                      <tr>
                        <td>Total</td>
                        <td>-</td>
                        <td>-</td>
                        <td>{{distanceTotal}}</td>
                        <td>{{co2Total}}</td>
                      </tr>
                    </tbody>
                  </table>
                }
              </div>
              @if (noData && arr.length == 0) {
                <div [innerHTML]="noData"></div>
              }
              <hr>
                <p class="pb-2 mb-2"><strong>Methodology</strong></p>
                <p>Strait Air Transport's Emission Calculator considers the different sections of the transport chain and applies industry recognized methods of calculation. The emissions calculated are average arithmetical values for a standard container
                  based on a variety of theoretical factors. Depending on input data emissions and actual route taken during shipment may diverge from these average arithmetical values. No liability is accepted for the completeness and accuracy
                  of these calculations.
                </p>
              </div>
            </div>

            <div class="col-lg-4 ps-md-4 ps-xl-5 pe-lg-0">
              <app-other-apps [menu]="'emission'"></app-other-apps>
            </div>
          </div>

        </div>
      </section>

      <app-sat></app-sat>

      <router-outlet></router-outlet>